(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/models/calendar.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/models/calendar.js');

'use strict';

svs.game_results.models.Calendar = Backbone.Model.extend({
  initialize(options) {
    this.set('productName', options.product);
    this.set('resultDates', []);
  },
  datesNotFetched(year, month) {
    return new Date(year, month, 1) < (this.get('resultDates')[0] ? new Date(this.get('resultDates')[0].date) : new Date());
  },
  getCalendarDates(year, month, successFn) {
    const self = this;
    let product = '';
    const live = false;
    switch (self.get('productName')) {
      case 'topptipset':
        product = 'topptipsetfamily';
        break;
      case 'powerplay':
      case 'stryktipset':
      case 'europatipset':
      case 'maltipset':
      case 'challenge':
      case 'bomben':
        product = self.get('productName');
        break;
      default:
        product = self.get('productName');
    }
    if (this.datesNotFetched(year, month)) {
      const path = "/draw/1/results/datepicker?product=".concat(product, "&year=").concat(year, "&month=").concat(month + 1, "&live=").concat(live);
      svs.core.jupiter.get(path, response => {
        if (response.resultDates && dateFns.isSameMonth(new Date(), new Date(year, month, 1))) {
          response.resultDates = _.filter(response.resultDates, draw => dateFns.isSameMonth(new Date(draw.date), new Date(year, month, 1)) || dateFns.isSameMonth(new Date(draw.date), new Date(year, month + 1, 1)));
        }

        if (response.resultDates && response.resultDates.length > 0) {
          const uniqueDraws = _.uniq(response.resultDates.concat(self.get('resultDates')), draw => draw.product + (draw.drawNumber ? draw.drawNumber : draw.date));
          self.set('resultDates', uniqueDraws);
          if (successFn) {
            successFn(true);
          }
        } else if (successFn) {
          successFn();
        }
        self.trigger('resultDates:fetched');
      }, error => {
        if (error.status !== 404) {
          svs.sport.sport_common.showErrorDialog('Nu gick något fel', "Kan inte h\xE4mta dragningar f\xF6r ".concat(self.get('productName'), ".<br>F\xF6rs\xF6k igen om en stund eller kontakta kundservice: 0770 - 11 11 11"));
        } else if (successFn) {
          successFn();
        }
        self.trigger('resultDates:fetched');
      });
    } else {
      if (successFn) {
        successFn();
      }
      self.trigger('resultDates:fetched');
    }
  }
});

 })(window);